import { Formik, Form } from 'formik' 
import * as Yup from 'yup';
import Button from '../components/Button'
import { toast } from 'react-toastify';
import { formatError, logError } from '../services/logging';
import EmailInput from '../components/Forms/EmailInput';
import { API_URL } from '../config/api';

const initialValues = {email: '',};

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Required"),
});

const PasswordResetRequest = () => {
  return (
    <main className="auth-container">
        <h2>Reset your password</h2>
        <p>Enter your email address below and we'll send you a link to reset your password.</p>

        <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    const resp = await fetch(`${API_URL}/api/reset_password`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(values)
                    })

                    const data = await resp.json()

                    if (resp.ok) {
                        toast.success("If an account with that email exists, a password reset link has been sent.")
                    } else {
                        logError(data)
                        toast.error(data.message || "Password reset failed")
                    }
                } catch (error) {
                    logError(formatError(error))
                    toast.error("An unexpected error occurred. Please try again.")
                } finally {
                    setSubmitting(false)
                }
            }}
        >
            {({ errors, touched, dirty, isValid, isSubmitting }) => (
                <Form>
                    <EmailInput errors={errors} touched={touched} />

                    <Button 
                        variant="primary" 
                        text="Send link" 
                        type="submit" 
                        disabled={!dirty || !isValid || isSubmitting}
                    />
                </Form>
            )}
        </Formik>
    </main>
  )
}

export default PasswordResetRequest